
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M16.125 0H1.875C.842 0 0 .84 0 1.875v14.25C0 17.159.842 18 1.875 18h14.25C17.158 18 18 17.16 18 16.125V1.875A1.877 1.877 0 0016.125 0zm.375 1.875V8.25H9.75V1.5h6.375c.207 0 .375.169.375.375zM1.875 1.5H8.25v6.75H1.5V1.875c0-.206.168-.375.375-.375zM1.5 16.125V9.75h6.75v6.75H1.875a.376.376 0 01-.375-.375zm14.625.375H9.75V9.75h6.75v6.375a.376.376 0 01-.375.375z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    